import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { Toaster } from 'sonner';
import { LoginScreen } from '@/components/login-screen';
import { Sidebar } from '@/components/layout/sidebar';
import { AuthProvider, useAuth } from '@/hooks/use-auth';
import { CostsPage } from '@/pages/costs';
import { InfrastructurePage } from '@/pages/infrastructure';
import { DevboxesPage } from '@/pages/devboxes';
import { IngestionPage } from '@/pages/ingestion';
import { ApiMetricsPage } from '@/pages/api-metrics';
import { ReleasePage } from '@/pages/release';

function Gate() {
  const { state } = useAuth();
  if (state.status === 'loading') return null;
  if (state.status === 'signedOut') return <LoginScreen />;
  return (
    <div className="flex h-screen">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<Navigate to="/costs" replace />} />
          <Route path="/costs" element={<CostsPage />} />
          <Route path="/ingestion" element={<IngestionPage />} />
          <Route path="/api-metrics" element={<ApiMetricsPage />} />
          <Route path="/infrastructure" element={<InfrastructurePage />} />
          <Route path="/devboxes" element={<DevboxesPage />} />
          <Route path="/release" element={<ReleasePage />} />
        </Routes>
      </main>
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Gate />
      </AuthProvider>
      <Toaster />
    </BrowserRouter>
  );
}
